import { environment } from '@environments/environment';

export const apiKeyEndpoints = [
  {
    // Login
    method: 'POST',
    endpoint: 'auth/login',
  },
  {
    // Create User
    method: 'POST',
    endpoint: 'users',
  },
];

export const apiKeyRequests = () =>
  apiKeyEndpoints.map(request => ({
    ...request,
    endpoint: `${environment.api.url}/${request.endpoint}/`,
  }));

export const isApiRequest = (url: string): boolean => {
  return url.startsWith(environment.api.url);
};

export const isApiKeyRequest = (
  url: string,
  method: string = 'GET'
): boolean => {
  return !!apiKeyRequests().find(
    request => request.endpoint.includes(url) && request.method === method
  );
};
